<template>
  <div class="eventTable">
    <PageTopForm>
      <div slot="form">
        <el-form-item label="关键字查询：">
          <el-input v-model="formInline.keyword" placeholder="对事件名称、事件类型查询" :maxlength="20" show-word-limit clearable @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="事件类型：">
          <el-select v-model="eventTypes" multiple collapse-tags placeholder="请选择（支持多选）" clearable @keyup.enter.native.stop="onSubmit">
            <el-option v-for="(k,v) in eventTypeOptions" :label="k" :value="v" :key="v"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拍摄时间：">
          <el-date-picker
            @change="changeDate"
            v-model="date"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div class="search-btn">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="default" @click="reset">重置</el-button>
          <el-button @click="$router.push({ path: '/controlPlatform/demandManagement', query: { backPage: backPage } })" class="backBtn">返 回</el-button>
        </div>
      </div>
    </PageTopForm>
    <div class="topButtons">
      <el-button type="primary" icon="el-icon-document-add" @click="importData" v-if="tableData.length && !showUpdateBtn && permissionLevel >= PermissionLevel.COMPILER">批量导入数据管理</el-button>
      <el-button type="primary" icon="el-icon-upload" @click="updateData" v-if="showUpdateBtn && tableData.length && permissionLevel >= PermissionLevel.COMPILER">更新数据成果</el-button>
    </div>
    <el-table
        ref="multipleTable"
        stripe
        :data="tableData"
        max-height="720"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          <span class="num">{{scope.$index+1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item ,index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :formatter="item.formatter"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="图片/视频" width="175">
        <template slot-scope="scope">
          <el-tooltip content="点击预览" placement="top" effect="light" :open-delay="50" :enterable="false">
            <div class="previewImgVideo">
              <div v-for="item,index in JSON.parse(scope.row.attachments)" :key="item.id"  @click="preview(scope.row, index)">
                <img :src="item.url" alt="png" v-if="index < 4 && item.format === 'image'">
                <img :src="item.url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_32,h_32'" alt="png" v-if="index < 4 && item.format === 'video'">
              </div>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="50">
        <template slot-scope="scope">
          <div class="action-btn">
            <el-tooltip content="详情" placement="top" effect="light" :open-delay="1000" :enterable="false">
              <Icon name="el-icon-document" @click="openDetails(scope.row)"></Icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <Empty style="min-height: 620px;padding-top: 200px"></Empty>
      </template>
    </el-table>
    <div class="page-bottom">
      <div class="page-wrapper">
        <div class="bottom-left">
          <span class="title">已选择</span><span class="value">{{selectedData.length}}</span><span  class="title">项，共</span><span class="value">{{total}}</span><span class="title">条</span>
        </div>
        <div class="bottom-right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>

      </div>
    </div>
    <PreviewPicture ref="PreviewPicture"></PreviewPicture>
    <Loading ref="Loading" @refresh="refreshTable"></Loading>
    <Details ref="Details"></Details>
  </div>
</template>

<script>
import PageTopForm from '@/components/PageTopForm/PageTopForm'
import page from '@/mixins/page'
import PreviewPicture from '@/components/PreviewPicture/PreviewPicture'
import Loading from './Dialog/Loading'
import Details from './Dialog/Details'
import { getDataList, getEventSelect } from '@/api/demandManagement'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'Tile',
  props: {},
  mixins: [page],
  components: { PageTopForm, PreviewPicture, Loading, Details },
  data () {
    return {
      eventTypeOptions: [],
      date: '',
      eventTypes: '',
      formInline: {
        pageNumber: 1,
        pageSize: 15,
        keyword: '',
        eventTypes: '',
        demandId: ''
      },
      columns: [
        {
          prop: 'name',
          label: '事件名称',
          width: 600
        },
        {
          prop: 'eventType',
          label: '事件类型',
          formatter: (row, column) => {
            return this.eventTypeOptions ? this.eventTypeOptions[row.eventType] : '无'
          }
        },
        {
          prop: 'longitude',
          label: '经度'
        },
        {
          prop: 'latitude',
          label: '纬度'
        },
        {
          prop: 'captureTime',
          label: '拍摄时间',
          formatter: (row, column) => {
            return new Date(row.captureTime).format('yyyy/MM/dd')
          }
        }
      ],
      showUpdateBtn: false,
      backPage: 0,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['permissionLevel'])
  },
  mounted () {
    if (this.$route.query.id) {
      this.formInline.demandId = this.$route.query.id
    }
    if (this.$route.query.backPage) {
      this.backPage = this.$route.query.backPage
    }
    this.loadTableData()
    this.getEventSelect()
  },
  methods: {
    reset () {
      this.formInline = this.$options.data().formInline
      this.eventTypes = ''
      this.date = ''
      this.loadTableData()
    },
    loadTableData () {
      if (this.eventTypes.length) {
        this.formInline.eventTypes = this.eventTypes.toString()
      } else {
        this.formInline.eventTypes = null
      }
      this.formInline.demandId = this.$route.query.id
      getDataList(this.formInline).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
          res.data.records.some(item => {
            if (item.status === 'IMPORTED') {
              this.showUpdateBtn = true
            } else {
              this.showUpdateBtn = false
            }
          })
        }
      })
    },
    getEventSelect () {
      getEventSelect().then((res) => {
        this.eventTypeOptions = res.data
      })
    },
    preview (row, index) {
      this.$refs.PreviewPicture.open(JSON.parse(row.attachments), index)
    },
    importData () {
      this.$refs.Loading.open('1', this.formInline.demandId)
    },
    updateData () {
      this.$refs.Loading.open('3', this.formInline.demandId)
    },
    openDetails (row) {
      this.$refs.Details.open('详情', 'details', row)
    },
    changeDate (date) {
      if (date) {
        this.formInline.start = date[0]
        this.formInline.end = date[1]
      } else {
        this.formInline.start = null
        this.formInline.end = null
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .eventTable{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    color: #ffffff;
    padding: 20px 32px 0px 32px;
    .previewImgVideo{
      display: flex;
      justify-content: start;
      align-items: center;
      img{
        width: 32px;
        height: 32px;
        border-radius: 6px;
        cursor: pointer;
        margin-right: 8px;
      }
    }
    .page-bottom {
        position: absolute;
        height: 54px;
        width: 100%;
        bottom: 0px;
        left: 0px;
        padding: 0 32px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 14px;
        .page-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .bottom-left {
            /*line-height: 1;*/
            .title{
              color: $font-color9;
            }
            .value{
              margin: 0px 10px;
              color: $font-colorf;
            }
          }
          .bottom-right{
            display: flex;
            align-items: center;
            .el-pagination{
              margin-top: 5px;
            }
          }
        }
      }
    .backBtn{
      transform: translateX(470px);
      border: 1px solid #ffffff54 !important;
      background-color: #3330 !important;
    }
  }
</style>
